import { MutableRefObject, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PrompterConfig } from './utils';
import { setStudioMainContainerHeight } from '../../store/modules/studio/actions';
import {
  selectIsOpenSettingsPanel,
  selectMainContainerHeight,
  selectStudioMode,
} from '../../store/modules/studio/selectors';

type Props = {
  mainViewContainerId: string;
  refControlStudioContainer: MutableRefObject<HTMLDivElement | null>;
};

const StudioResizeListener = (
  { mainViewContainerId, refControlStudioContainer }: Props,
) => {
  const dispatch = useDispatch();
  const mainContainerHeight = useSelector(selectMainContainerHeight);
  const studioMode = useSelector(selectStudioMode);
  const isOpenSettingsPanel = useSelector(selectIsOpenSettingsPanel);

  const resizeMainContainer = useCallback(() => {
    const screenHeight = window.innerHeight;
    const control = refControlStudioContainer.current;
    if (control) {
      let actualHeight = screenHeight - control.offsetHeight - 30;
      if (actualHeight < PrompterConfig.minHeightPrompter) {
        actualHeight = PrompterConfig.minHeightPrompter;
      }
      if (mainContainerHeight !== actualHeight) {
        dispatch(setStudioMainContainerHeight(actualHeight));
      }
    }
  }, [dispatch, refControlStudioContainer, mainContainerHeight]);

  useEffect(() => {
    const onResize = resizeMainContainer;
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [resizeMainContainer]);

  useEffect(() => {
    resizeMainContainer();
  }, [studioMode, resizeMainContainer, isOpenSettingsPanel]);

  /* eslint-disable react-hooks/exhaustive-deps, no-param-reassign */
  useEffect(() => {
    const mainContainer = document.getElementById(mainViewContainerId);
    if (mainContainer) {
      mainContainer.style.height = `${mainContainerHeight}px`;
    }
  }, [mainViewContainerId, mainContainerHeight]);

  return null;
};

export default StudioResizeListener;
